module.exports = __webpack_public_path__ + "img/jiayong.871fb4be.jpg";